import { motion } from "framer-motion";
import logo from '../assets/saas.png'

export default function About() {
  return (
    <section className="about">
      <motion.div
        className="about-container"
        id="about"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        <div className="about-text">
          <div className="about-text-top">
            <nav>About</nav>
            <h2>Ellentra Technologies</h2>
          </div>
          <p>
            Ellentra Technologies is a forward-thinking digital solutions company
            focused on building reliable, scalable, and impactful technology
            products for businesses, organisations, and communities.
          </p>
          <p>
            We specialise in modern system development, web and application
            solutions, and software-as-a-service platforms designed to solve
            real-world problems. Our approach blends innovation, strategy, and
            technical excellence to deliver results that last.
          </p>
          <p>
            Through Ellentra Academy, we also invest in digital skills development,
            equipping individuals with practical technology knowledge that empowers
            growth, independence, and long-term success.
          </p>
        </div>

        <div className="about-image">
          <img
            src={logo}
            alt="Ellentra team"
          />
        </div>
      </motion.div>
    </section>
  );
}
